import React from "react";
import { Grid } from "@mui/material";
import EmployeeFullName from "./../EmployeeFullName";
import EmployeeDesignation from "./../EmployeeDesignation";
import "./ChangeProfilePic.css";
import ReporterType from "../../../infra/aggregates/reportsToInterface";
import UpdateProfilePic from "../UpdateProfilePic/UpdateProfilePic";
import UpdateProfilePicController from "../UpdateProfilePic/UpdateProfilePicController";

interface eventList {
  reporter: ReporterType;
}

const ChangeProfilePicPresenter = ({ reporter }: eventList) => {
  return (
    <Grid container>
      <Grid item xs={12} className="pic_box">
        <UpdateProfilePicController />
      </Grid>
      <Grid item xs={12} className="name_box">
        <EmployeeFullName first_name={reporter.emp_name} last_name={""} />
      </Grid>
      <Grid item xs={12} className="designation_box">
        <EmployeeDesignation designation={reporter.emp_designation} />
      </Grid>
    </Grid>
  );
};
export default ChangeProfilePicPresenter;
